/* eslint-disable import/prefer-default-export */
// TODO find an alternative to hard-coding this product handle
export const MATTRESS_FEE_HANDLE = "mattress-fee";
